import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';

import * as utils from 'utils/utils';
import { segmentsData } from '../../../product-details/segments-data-stub';
import { BaseSegmentComponent } from '../base/_base-segment.component';


@Component({
  moduleId: module.id,
  selector: 'ecommerce-shipping',
  templateUrl: 'shipping.component.html',
  styleUrls: ['shipping.component.scss'],
})
export class ShippingComponent extends BaseSegmentComponent implements OnInit {

  packageFields: Array<string> = [
    'EA.dimensions.length',
    'EA.dimensions.width',
    'EA.dimensions.height',
    'EA.weights.weight',
    'EA.package_level_GTIN',
    'EA.dimensions.uom',
    'EA.weights.uom',
  ];
  descriptionField: string = 'descriptions.SHP';
  descriptionSHPSegment: any;
  packageSegments: Array<any>;

  get dimentionsUom(): string {
    return _.get(this.itemDetail, 'packages.EA.dimensions.uom') === 'IN'
    ? '”' : 'cm';
  }

  get weightUom(): string {
    return _.get(this.itemDetail, 'packages.EA.weights.uom') === 'PG' ?
    'lbs' : 'kg';
  }

  get itemInvalid(): boolean {
    return _.some(this.packageFields, (field) => {
      return _.get(this.itemDetail, 'validation.combinedErrors', [])
      .indexOf(`packages.${field}`) !== -1;
    }) || _.get(this.itemDetail, 'validation.combinedErrors', [])
      .indexOf(`${this.descriptionField}.${this.selectedLanguage}`) !== -1;
  }

  ngOnInit() {
    this.descriptionSHPSegment = _.find(
      segmentsData.descriptions,
      ['item_name', this.descriptionField]
    );
    this.packageSegments = _.filter(
      segmentsData.packages,
      (item: any) => _.includes(this.packageFields, item.item_name)
    );
  }

  showPackageField(itemName: string): boolean {
    return itemName.indexOf('uom') === -1;
  }

  getPackageProperty(item: any): string {
    return utils.getItemProperty(
      item,
      item.item_name,
      this.itemDetail.packages
    );
  }

}
